export enum Title {
  MALE = 'Male',
  FEMALE = 'Female',
  DIVERSE = 'Divers',
}
